//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ArMenuItem",
  props: {
    link: {
      type: String
    },
    show: {
      type: [Boolean, Function]
    },
    icon: {
      type: String
    },
    label: {
      type: String
    }
  }
};
